module.exports = __webpack_public_path__ + "static/media/air-conditioner.f48f8e70.svg";